"use client";
import { useState } from "react";
const faqs = [
    {
        question: "What is General Surgery and what conditions does it treat?",
        answer: "General surgery involves the surgical treatment of conditions related to the abdomen, digestive system, soft tissues, hernia, appendix, gallbladder, thyroid, and more.",
    },
    {
        question: "When should I consult a general surgeon in Patna?",
        answer: "You should consult a general surgeon if you experience persistent abdominal pain, swelling, hernia symptoms, gallstones, piles, or if your doctor recommends surgery.",
    },
    {
        question: "Is laparoscopic surgery better than open surgery?",
        answer: "Yes, laparoscopic (minimally invasive) surgery usually offers smaller cuts, less pain, faster recovery, and shorter hospital stays compared to traditional open surgery.",
    },
    {
        question: "How long does it take to recover after general surgery?",
        answer: "Recovery time depends on the type of procedure. Minimally invasive surgeries may take a few days to weeks, while major surgeries may require longer recovery.",
    },
    {
        question: "Is general surgery safe?",
        answer: "Yes, general surgery is safe when performed by experienced surgeons using advanced techniques and proper post-operative care.",
    },
    {
        question: "What are the common surgeries performed in general surgery?",
        answer: "Common procedures include hernia repair, appendix removal, gallbladder surgery, piles treatment, thyroid surgery, and breast surgery.",
    },
    {
        question: "Do you provide emergency general surgery services in Patna?",
        answer: "Yes, 24×7 emergency surgical services are available for conditions like appendicitis, trauma, and acute abdominal pain.",
    },
    {
        question: "How do I prepare for a general surgery?",
        answer: "Preparation may include medical tests, fasting before surgery, stopping certain medications, and following your doctor’s instructions carefully.",
    },
    {
        question: "What is the cost of general surgery in Patna?",
        answer: "The cost varies depending on the type of surgery, complexity, and hospital facilities. A consultation with the surgeon will provide an accurate estimate.",
    },
    {
        question: "How can I book an appointment for general surgery consultation?",
        answer: "You can book an appointment by calling the hospital, visiting the website, or directly visiting the hospital for consultation.",
    }
];
export default function FaqSection() {
    const [activeIndex, setActiveIndex] = useState(null);
    const leftFaqs = faqs.slice(0, 5);
    const rightFaqs = faqs.slice(5, 10);
    const toggleFaq = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const renderFaqs = (faqList, offset) =>
        faqList.map((faq, index) => {
            const currentIndex = index + offset;
            return (
                <div key={currentIndex} className="faq-box" onClick={() => toggleFaq(currentIndex)} >
                    {/* Question */}
                    <div className={`faq-question ${activeIndex === currentIndex ? "active" : ""}`}>
                        <h6>{faq.question}</h6>
                        <span className="icon"> {activeIndex === currentIndex ? "−" : "+"}</span>
                    </div>
                    {/* Answer */}
                    {activeIndex === currentIndex && (
                        <div className="faq-answer"> <p>{faq.answer}</p> </div>
                    )}
                </div>
            );
        });

    return (
        <section className="faq-section container">
            <div className="row">
                {/* Left Column */}
                <div className="col-lg-6">{renderFaqs(leftFaqs, 0)}</div>
                {/* Right Column */}
                <div className="col-lg-6">{renderFaqs(rightFaqs, 5)}</div>
            </div>
        </section>
    );
}
